import { render, staticRenderFns } from "./SinglePatient.vue?vue&type=template&id=0417d163&"
import script from "./SinglePatient.vue?vue&type=script&lang=js&"
export * from "./SinglePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports